import { ApolloClient, from, InMemoryCache } from '@apollo/client'
import { onError } from '@apollo/client/link/error'
import { isBrowser } from '@utils/isBrowser'
import { RestLink } from 'apollo-link-rest'
import camelCase from 'camelcase'
import tokenService from '@utils/services/tokenServices'
import formatResponse from './formatResponse'
import formatBodyKeys from './formatBodyKeys'

const activeEnv = process.env.GATSBY_ACTIVE_ENV || process.env.NODE_ENV || 'development'
const clientLinks = []

export const authHeaders = (): RestLink.InitializationHeaders => {
  const token = tokenService.getToken()
  return token ? { 'x-ewoz-id-token': token } : {}
}

if (isBrowser) {
  const restLink = new RestLink({
    uri: process.env.GATSBY_API_URL,
    customFetch: fetch,
    responseTransformer: async resp => {
      if (resp === null || resp?.status === 404 || resp?.status === 500) {
        throw new Error(`Er is een fout opgetreden. Probeer het opnieuw of neem contact op met onze support.`)
      }

      if (resp?.status) {
        return resp.json().then((data: any) => formatResponse(resp, data))
      }

      return {}
    },
    fieldNameNormalizer: name => camelCase(name),
    bodySerializers: {
      kebabizeObject: (data, headers) => ({
        body: JSON.stringify(formatBodyKeys(data), (key, value) => {
          // We need to explicitly define types, otherwise they will be converted to strings
          if (typeof value === 'boolean') {
            return Boolean(value)
          } else if (typeof value === 'number') {
            return Number(value)
          }

          return value
        }),
        headers,
      }),
      fileEncode: (data: any, headers: Headers) => {
        const formData = new FormData()
        formData.append('file', data.file, data.file.name)
        headers.set('Accept', '*/*')
        headers.delete('content-type')

        return {
          body: formData,
          headers,
        }
      },
    },
    headers: {
      'Content-Type': 'application/json',
      ...authHeaders(),
    },
  })

  const errorLink = onError(({ graphQLErrors, networkError, ...props }) => {
    if (graphQLErrors) {
      // Loop over the graphQL errors, maybe the message is empty due to using the REST API, we need some manual work
      graphQLErrors.map(graphQLError => {
        if (!graphQLError.message) {
          // @ts-ignore
          graphQLError.message = graphQLError?.reasons[0]
        }
      })

      graphQLErrors.forEach(({ message, locations, path }) => {
        if (message?.toLowerCase().includes('unauthenticated')) {
          if (activeEnv !== 'development') {
            //logout()
          }
        }
        console.log(`[API error]: Message: ${message}, Location: ${locations}, Path: ${path}`)
      })
    }

    if (networkError) {
      console.log('Network', networkError)
      console.log(`[Network error]: ${networkError}`)
    }
  })

  clientLinks.push(errorLink, restLink)
}

export const client = new ApolloClient({
  link: from(clientLinks),
  cache: new InMemoryCache(),
})
